import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "filters-wrapper gap-20 justify-content-between align-items-start" }
const _hoisted_2 = { class: "filters w-100 align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "filters-text pdt-10" }, " Filters: ", -1)
const _hoisted_4 = { class: "work-history-filters d-flex flex-column flex-lg-row gap-15 align-items-start w-100" }
const _hoisted_5 = { class: "custom-select links w-100" }
const _hoisted_6 = { class: "custom-select links w-100" }
const _hoisted_7 = { class: "custom-select links w-100" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex gap-20 w-50 w-sm-100"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-printer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        class: "filters w-100 flex-column align-items-start",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFilters && _ctx.submitFilters(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SelectComponent, {
            selectedOption: _ctx.filters.period,
            "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.period) = $event)),
            options: _ctx.dateFilterOptions,
            singleArrow: true,
            "custom-class": "w-100"
          }, null, 8, ["selectedOption", "options"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_multiselect, {
              label: "OrgName",
              "track-by": "EmployerID",
              modelValue: _ctx.selectedEmployers,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEmployers) = $event)),
              options: _ctx.employersOptions,
              multiple: true,
              showNoOptions: false,
              placeholder: _ctx.emplDropdownOpened? 'Start typing to search for Employers' : 'All Employers',
              onOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDropdownOpen('empl'))),
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDropdownOpen('empl'))),
              onSearchChange: _ctx.searchEmployers,
              onSelect: _ctx.updateEmployerSelection
            }, null, 8, ["modelValue", "options", "placeholder", "onSearchChange", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_multiselect, {
              label: "OrgName",
              "track-by": "ProductionID",
              modelValue: _ctx.selectedProductions,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedProductions) = $event)),
              options: _ctx.productionsOptions,
              multiple: true,
              placeholder: _ctx.prodDopdownOpened? 'Start typing to search for Productions' : 'All Productions',
              onOpen: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleDropdownOpen('prod'))),
              onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleDropdownOpen('prod'))),
              onSearchChange: _ctx.searchProductions,
              onSelect: _ctx.updateProductionSelection
            }, null, 8, ["modelValue", "options", "placeholder", "onSearchChange", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_multiselect, {
              label: "name",
              "track-by": "id",
              modelValue: _ctx.selectedFunds,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFunds) = $event)),
              options: _ctx.fundsOptions,
              multiple: true,
              placeholder: "All Funds"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_ctx.filters.period?.key === 'custom_range')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_DateInput, {
                modelValue: _ctx.filters.from_date,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.from_date) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_DateInput, {
                modelValue: _ctx.filters.to_date,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.to_date) = $event)),
                error: _ctx.errors
              }, null, 8, ["modelValue", "error"])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-secondary text-nowrap lh-1 pdt-10 pdb-10 plan-modal",
      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.printHistory && _ctx.printHistory(...args)), ["prevent"])),
      disabled: _ctx.loading || _ctx.disabled || _ctx.printing
    }, [
      _hoisted_10,
      _createTextVNode(),
      _createElementVNode("span", null, _toDisplayString(_ctx.printing ? 'Printing...' : 'Print PDF'), 1)
    ], 8, _hoisted_9)
  ]))
}